// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"228":"22028400","239":"67ba7847","488":"9bd34e16"}[chunkId] + ".chunk.js";
};